export default "__VITE_ASSET__2ac9789e__"